export default "__VITE_ASSET__bItbAsky__"